export default {
    blackList_00001: "Lista negra",
    blackList_00002: "Por favor, introduzca el nombre de usuario/número de móvil",
    blackList_00003: "Una vez que el usuario esté en la lista negra, la microseñal, el número de teléfono móvil y otras microseñales correspondientes al mismo número de teléfono móvil no podrán cargarse en el sitio",
    blackList_00004: "Motivo",
    blackList_00005: "Por favor, introduzca el motivo por el que el usuario está en la lista negra, máximo 20 caracteres",
}